// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"35d1572e","373":"ddc7b784","453":"6c7a1784","483":"373609b5","684":"abe6098e"}[chunkId] + ".chunk.js";
};